(function(angular){
	'use strict';
	
	angular.module('goalTeaserModule', [
		'BaseConfig',
		'serviceLevelModule'
	]);
})(window.angular);